<template>
  <div class="main-banner alert border-0 rounded-0 py-2 py-md-3 mb-0" role="alert" :style="style">
    <span v-html="text"></span>
    <a v-if="options.linkText && options.linkHref" :href="options.linkHref" class="ml-2">{{ options.linkText }}</a>
  </div>
</template>

<script>
  export default {
    name: 'RentalItem',
    props: {
      text: {
        default: ''
      },
      options: {
        default: ''
      }
    },
    data() {
      return {
      };
    },
    computed: {
      style() {
        const { textColor, background, fontSize, fontWeight, textAlign } = this.options;
        return {
          color: `var(--${textColor})`,
          background: `var(--${background})`,
          fontSize: `${fontSize}px`,
          fontWeight,
          textAlign
        };
      }
    }
  };
</script>
<style lang="scss" scoped>
  .main-banner {
    line-height: 1.3;
    font-weight: bold;
    background-color: var(--primary);
    color: #fff;
    font-size: 14px;
  }
  @media (max-width: 475px) {
    .main-banner {
      font-size: 12px !important;
      font-weight: bold !important;
    }
  }
</style>
